<template lang="pug">
.milestone-page
  .title(@click='goToLastPage')
    span 里程碑

  .arrow-block(
    @animationend='step++'
    :class="{ 'slide-in': typeof step === 'number' }"
    :style="{ '--slide-duration': `${STEP_SECONDS.STEP_0}s` }"
    )
    img(:src='arrowSrc' width='84px')

  template(v-for='m in milestoneList')
    .milestone-block(
      :style='milestonePosition(m)'
      :class="{ 'fade-in': m.visible }"
      )
      .icon-circle
        div(v-if='m.showLogo' style='margin: 3px auto auto 5px;')
          img(:src='aesLogoImgSrc' width='48px')
      .text-block
        .milestone-title {{ m.title }}
        .milestone-time {{ m.time }}
</template>

<script>
export default {
  data () {
    return {
      step: null,
      STEP_SECONDS: {
        STEP_0: 2,
        STEP_1: 5,
        STEP_2: 5,
        STEP_3: 5,
        STEP_4: 5,
        STEP_5: 5,
        STEP_6: 5
      },
      milestoneList: [
        {
          visible: false,
          top: 1600 - 267 * 0,
          left: 40,
          title: '可行性評估',
          time: '108 年 9 月 ~ 109 年 10 月',
          showLogo: true
        },
        {
          visible: false,
          top: 1600 - 267 * 1,
          left: 40,
          title: '標租作業',
          time: '110 年 3 月 ~ 110 年 8 月',
          showLogo: false
        },
        {
          visible: false,
          top: 1600 - 267 * 2,
          left: 40,
          title: '行政作業',
          time: '110 年 9 月 ~ 111 年 5 月',
          showLogo: false
        },
        {
          visible: false,
          top: 1600 - 267 * 3,
          left: 40,
          title: '設置階段',
          time: '110 年 2 月 ~ 111 年 11 月',
          showLogo: false
        },
        {
          visible: false,
          top: 1600 - 267 * 4,
          left: 40,
          title: '併聯完成',
          time: '112 年 1 月',
          showLogo: false
        },
        {
          visible: false,
          top: 1600 - 267 * 5,
          left: 40,
          title: '開幕啟用',
          time: '112 年 4 月',
          showLogo: false
        }
      ],

      /**
       * 圖片路徑
       */
      arrowSrc: require('@/assets/milestone/arrow.svg'),
      aesLogoImgSrc: require('@/assets/milestone/logo_48_aes_marque.svg')
    }
  },
  mounted () {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.step = 0
        this.logger(this.step, this.STEP_SECONDS.STEP_0)
      })
    })
  },
  methods: {
    logger (step, seconds = 0) {
      if (step > this.milestoneList.length) {
        console.log('Milestone: 結束')
        return
      }

      console.log(`Milestone: step ${step}, 秒數: ${seconds}s`)
    },
    handleStep (step) {
      console.log(step)

      const duration = this.STEP_SECONDS[`STEP_${step}`] ?? 0
      this.logger(step, duration)

      if (step > this.milestoneList.length) {
        this.$emit('next')
        return
      }

      const milestoneIdx = step - 1
      this.showMilestone(milestoneIdx, duration)
    },
    showMilestone (milestoneIdx, duration) {
      if (milestoneIdx > 0) {
        this.milestoneList[milestoneIdx - 1].showLogo = false
      }

      this.milestoneList[milestoneIdx].visible = true
      this.milestoneList[milestoneIdx].showLogo = true

      window.setTimeout(() => {
        this.step++
      }, duration * 1000)
    },
    milestonePosition (i) {
      return {
        position: 'absolute',
        top: i.top + 'px',
        left: i.left + 'px'
      }
    },
    goToLastPage () {
      this.$emit('skip')
    }
  },
  watch: {
    step: {
      handler (newStep, oldStep) {
        if (newStep > oldStep) {
          this.handleStep(newStep)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.milestone-page {
  width: 100%;
  height: 100%;
  position: relative;

  .title {
    height: 140px;
    text-align: center;
    line-height: 140px;
    background: linear-gradient(to bottom, rgba(0, 220, 255, 0.4), rgba(0, 220, 255, 0));

    span {
      font-family: 'Noto Sans TC', sans-serif;
      font-size: 52px;
      font-weight: 700;
      letter-spacing: 14.44px;
      color: #0064a0;
    }
  }

  .arrow-block {
    position: absolute;
    left: 48px;
    bottom: -5px;

    transform: translateY(100%);
    &.slide-in {
      animation-name: slideIn;
      animation-duration: var(--slide-duration, 2s); // 箭頭 slide in
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }
  }

  @keyframes slideIn {
    0% {
      transform: translateY(100%);
    }

    66% {
      transform: translateY(90%);
    }

    100% {
      transform: translateY(0%);
    }
  }

  .milestone {
    opacity: 0;
    &.fade-in {
      animation-name: fadeIn;
      animation-duration: 0.6s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .milestone-block {
    position: relative;
    width: 393px;
    height: 140px;
    opacity: 0;

    &.fade-in {
      animation-name: fadeIn;
      animation-duration: 0.6s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;
    }

    .icon-circle {
      z-index: 1;
      position: absolute;
      top: 31px;
      left: 14px;

      width: 70px;
      height: 70px;
      border-radius: 100%;
      background: white;
      border: 6px solid #0078FF;
      box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.5);
    }

    .text-block {
      position: absolute;
      top: 8px;
      left: 83px;

      width: 300px;
      height: 120px;

      text-align: center;

      background: #FFFFFF;
      box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
      border-radius: 16px;
    }

    .milestone-title {
      font-family: 'Noto Sans TC';
      font-size: 44px;
      color: #2371bf;
      letter-spacing: 0.04em;
      margin-top: 10px;
      font-weight: 400;
    }

    .milestone-time {
      font-family: Arial, Helvetica, sans-serif;
      font-size: 20px;
      color: #8C8C8C;
    }
  }

  .aes-logo {
    width: 48px;
    height: 48px;
  }
}

</style>
